<template>
    <div id="banner" :style="`backgroundImage:url(${bgImage})`">
        <div class="banner_mask">
            <div class="link_tab" v-if="!!links">
                <ul>
                    <li v-for="(link,index) in links" :key="index">
                        <a :href="link.url" ref="link">
                            {{link.title}}
                            <div></div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="content">
                <h1>{{title}}</h1>
                <ul class="breadcrumbs">
                    <li v-for="(item,index) in breadcrumbs" :key="index">
                        <a v-if="item.url" :href="item.url">{{item.title}}</a>
                        <span v-if="!item.url">{{item.title}}</span>
                        <span v-if="index !== breadcrumbs.length -1 ">></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Banner",
    components: {},
    props: {
        title: {
            type: String,
            default: "標題"
        },
        breadcrumbs: {
            type: Array,
            default: function() {
                return [
                    {
                        url: "/",
                        title: "首頁"
                    },
                    {
                        title: "中間頁面"
                    },
                    {
                        url: "#",
                        title: "當前頁面"
                    }
                ];
            }
        },
        type: ""
    },
    data() {
        return {};
    },
    methods: {},
    computed: {
        links: {
            get() {
                const vm = this;
                let All = {
                    activity: [
                        {
                            url: "/Academic/Calendar",
                            title: "行事曆"
                        },
                        {
                            url: "/Academic/Activity",
                            title: "學術活動"
                        },
                        {
                            url: "/Academic/Silhouette",
                            title: "活動花絮"
                        }
                    ],
                    society: [
                        {
                            url: "/Society/Index",
                            title: "學會沿革"
                        },
                        {
                            url: "/Society/Chapter",
                            title: "學會章程"
                        },
                        {
                            url: "/Society/Words",
                            title: "理事長的話"
                        },
                        {
                            url: "/Society/Supervisory",
                            title: "理監事名錄"
                        }
                    ],
                    information: [
                        {
                            url: "/Conference/Journals",
                            title: "會刊資訊"
                        },
                        {
                            url: "/Conference/DigitalVideos",
                            title: "影像數位平台"
                        },
                        // {
                        //     url: "/Conference/RelatedInformation",
                        //     title: "會員專屬資訊"
                        // }
                    ],
                    health: [
                        {
                            url: "/HealthEducation",
                            title: "衛教資訊"
                        },
                        {
                            url: "/HealthEducation/HealthVideos",
                            title: "影像衛教"
                        }
                    ],
                    decision: [
                        {
                            url: "/MedicalDecision/Index",
                            title: "醫病共同決策"
                        },
                        {
                            url: "/MedicalDecision/Feedback",
                            title: "醫病決策回饋"
                        }
                    ],
                    submission: [
                        {
                            url: "/Submission/Index",
                            title: "線上投稿"
                        },
                        {
                            url: "/Submission/Admission",
                            title: "錄取名單"
                        }
                    ],
                    member: [
                        {
                            url: "/Member/Status",
                            title: "年會費繳納"
                        },
                        {
                            url: "/Member/Index",
                            title: "會員資料"
                        },
                        {
                            url: "/Member/Record",
                            title: "活動報名紀錄"
                        },
                        {
                            url: "/Member/Password",
                            title: "修改密碼"
                        }
                    ]
                };

                return All[vm.type];
            }
        },
        bgImage: {
            get() {
                const vm = this;
                switch (vm.type) {
                    case "activity":
                        return "/static/images/banner/banner9.jpg";
                        break;
                    case "society":
                        return "/static/images/banner/banner3.jpg";
                        break;
                    case "information":
                        return "/static/images/banner/banner1.jpg";
                        break;
                    case "decision":
                        return "/static/images/banner/banner5.jpg";
                        break;
                    case "submission":
                        return "/static/images/banner/banner6.jpg";
                        break;
                    case "member":
                        return "/static/images/banner/banner7.jpg";
                        break;
                    case "enroll":
                        return "/static/images/banner/banner8.jpg";
                        break;
                    case "news":
                        return "/static/images/banner/banner2.jpg";
                        break;
                    case "health":
                        return "/static/images/banner/banner10.jpg";
                        break;
                    default:
                        return "/static/images/banner/banner1.jpg";
                        break;
                }
            }
        }
    },
    created() {},
    mounted() {
        const vm = this;
        if (!!vm.links && vm.links.length > 0) {
            let url = location.pathname.split("/").pop();
            vm.$refs.link.forEach(item => {
                // console.log(item.href);
                if (item.href.split("/").pop() === url) {
                    item.classList.add("active");
                }
                if (
                    url === "Health" &&
                    item.href.split("/").pop() === "Healths"
                ) {
                    item.classList.add("active");
                }
                if (
                    url === "DigitalVideo" &&
                    item.href.split("/").pop() === "DigitalVideos"
                ) {
                    item.classList.add("active");
                }
            });
        }
    },
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#banner {
    margin-top: 131px;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    position: relative;
}
#banner .banner_mask {
    background: -moz-linear-gradient(
        top,
        rgba(30, 30, 30, 0.5) 0%,
        rgba(0, 0, 0, 0.21) 30%,
        rgba(0, 0, 0, 0.2) 52%,
        rgba(0, 0, 0, 0.19) 70%,
        rgba(30, 30, 30, 0.5) 100%
    );
    background: -webkit-linear-gradient(
        top,
        rgba(30, 30, 30, 0.5) 0%,
        rgba(0, 0, 0, 0.21) 30%,
        rgba(0, 0, 0, 0.2) 52%,
        rgba(0, 0, 0, 0.19) 70%,
        rgba(30, 30, 30, 0.5) 100%
    );
    background: linear-gradient(
        top,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(0, 0, 0, 0) 30%,
        rgba(0, 0, 0, 0) 52%,
        rgba(0, 0, 0, 0) 70%,
        rgba(0, 0, 0, 0.3) 100%
    );
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    align-items: flex-end;
}
#banner .banner_mask .link_tab {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    position: relative;
    z-index: 3;
}
#banner .banner_mask .link_tab ul {
    display: flex;
    justify-content: space-between;
    width: 70%;
    margin: 0 auto;
}
#banner .banner_mask .link_tab ul li {
    flex-grow: 1;
}
#banner .banner_mask .link_tab ul li a {
    width: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    padding: 20px 0;
    display: inline-block;
    position: relative;
    line-height: 1.2;
}
#banner .banner_mask .link_tab ul li a:after {
    content: "";
    width: 1px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.2);
}
#banner .banner_mask .link_tab ul li:nth-last-child(1) a::before {
    content: "";
    width: 1px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.2);
}
#banner .banner_mask .link_tab ul li a div {
    background-color: #ee8b59;
    width: 100%;
    height: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: 0.5s;
}
#banner .banner_mask .link_tab ul li a.active div {
    height: 8px;
}
#banner .banner_mask .link_tab ul li a:hover div {
    height: 8px;
}
#banner .content {
    padding: calc(10%) 0;
}
#banner .content h1 {
    color: #fff;
    padding: 10px 0;
    position: relative;
    z-index: 2;
}
#banner .breadcrumbs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    z-index: 2;
}
#banner .breadcrumbs li {
    padding: 10px 8px 10px 0;
}
#banner .breadcrumbs li a,
#banner .breadcrumbs li span {
    color: #fff;
    font-size: 1.2rem;
    text-decoration: none;
}
#banner .breadcrumbs li a:nth-last-child(1) {
    color: #fff;
}
@media screen and (max-width: 1400px) {
    #banner .banner_mask .link_tab ul {
        width: 80%;
    }
}
@media screen and (max-width: 1200px) {
    #banner {
        margin-top: 68.56px;
    }
    #banner .banner_mask .link_tab ul {
        width: 90%;
    }
}
@media screen and (max-width: 992px) {
    #banner {
        margin-top: 68.56px;
    }

    #banner .content {
        padding: 13.054% 0;
    }
}
@media screen and (max-width: 767px) {
    #banner .banner_mask .link_tab ul {
        width: 100%;
    }
    #banner .content {
        padding: 25% 2.5%;
    }
    #banner .content h1 {
        width: 100%;
        margin: auto;
    }
    #banner .breadcrumbs {
        width: 100%;
        margin: auto;
    }
    #banner .banner_mask .link_tab ul li a {
        padding: 15px 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/banner/index.vue